import * as React from 'react';
import { ComponentOverrides } from '../../../models';
import { IRuntimeHandlerConfig } from '../../../types/configuration.types';
interface IComponentOverrideProps {
  componentName: ComponentOverrides;
  callbackHandlers: Partial<IRuntimeHandlerConfig>;
}
export const ComponentOverride = (props: IComponentOverrideProps & any) => {
  if (
    !props.componentName ||
    !props.callbackHandlers ||
    !props.callbackHandlers.GetComponent ||
    typeof props.callbackHandlers.GetComponent !== 'function'
  ) {
    return null;
  }

  const Component: React.ComponentType<any> = props.callbackHandlers.GetComponent(props.componentName);

  if (!Component) {
    return null;
  } else {
    if (React.isValidElement(Component)) {
      return Component;
    } else {
      const componentProps = { ...props };
      componentProps.componentName = undefined;
      componentProps.callbackHandlers = undefined;
      return <Component {...props} />;
    }
  }
};
